import Component from "../../component";

export const ResponsiveImageConfig = {
    signature: 'responsiveImage',
    baseHtmlClass: 'responsive_image',
    selector: '.responsive_image',
    initedHtmlClassModifier: 'inited',
    srcChangedHtmlClassModifier: 'changed',
    configDataKey: 'responsiveImageConfigData',

    minSrcUrlDatasetKey: 'responsive_image__src_url__min',
    tinySrcUrlDatasetKey: 'responsive_image__src_url__tiny',
    smallSrcUrlDatasetKey: 'responsive_image__src_url__small',
    mediumSrcUrlDatasetKey: 'responsive_image__src_url__medium',
    largeSrcUrlDatasetKey: 'responsive_image__src_url__large',
    hugeSrcUrlDatasetKey: 'responsive_image__src_url__huge',
};

export class ResponsiveImage extends Component {

    static applyToAll() {
        document.querySelectorAll(ResponsiveImageConfig.selector).forEach((element) => {
            if (!ResponsiveImage.isElementComponentized(element, ResponsiveImageConfig.signature)) new ResponsiveImage(element);
        });
    }

    constructor(id_or_element, props = {}) {
        super({
            element: id_or_element,
            config: ResponsiveImageConfig
        });

        this.breakpointSrcUrls = this.getBreakpointSrcUrls();

        this.originalSrcUrl = this.element.getAttribute('src');
        this.defaultSrcUrl = this.breakpointSrcUrls['min'];

        this.updateWidth();

        this.isResizeTicking = false;
        const resizeObserver = new ResizeObserver(this.resizeHandler.bind(this));
        resizeObserver.observe(this.element);

        this.inited = true;
        this.render();
    }

    // This resize handler throttles the calls to `handleResize` which actually does the work.
    resizeHandler() {
        if (!this.isResizeTicking) {
            window.requestAnimationFrame(() => {
                this.handleResize();
                this.isResizeTicking = false;
            });
            this.isResizeTicking = true;
        }
    };

    handleResize() {
        this.updateWidth();
        this.render();
    }


    render() {
        this.conditionallySetHtmlClassState(this.inited, ResponsiveImageConfig.initedHtmlClassModifier);
        this.renderImgSrc();
    }

    getImgWidth() {
        return this.element.offsetWidth;
    }

    renderImgSrc() {
        let src = this.getImgSrc();
        if (src) {
            let img = new Image();
            img.addEventListener('load', (event)=>{
                this.element.src = src;
                this.conditionallySetHtmlClassState((src !== this.originalSrcUrl), ResponsiveImageConfig.srcChangedHtmlClassModifier);
            });
            img.src = src;
        }
    }

    // Examine the width to determine the appropriate breakpoint.
    getBreakPoint() {
        return new BreakpointFinder(this.width).getKey();
    }

    getImgSrc() {
        return this.breakpointSrcUrls[this.breakpoint] || this.defaultSrcUrl || this.originalSrcUrl;
    }

    getBreakpointSrcUrls() {
        return {
            "min": this.element.dataset[ResponsiveImageConfig.minSrcUrlDatasetKey],
            "tiny": this.element.dataset[ResponsiveImageConfig.tinySrcUrlDatasetKey],
            "small": this.element.dataset[ResponsiveImageConfig.smallSrcUrlDatasetKey],
            "medium": this.element.dataset[ResponsiveImageConfig.mediumSrcUrlDatasetKey],
            "large": this.element.dataset[ResponsiveImageConfig.largeSrcUrlDatasetKey],
            "huge": this.element.dataset[ResponsiveImageConfig.hugeSrcUrlDatasetKey],
        }
    }

    // When we set the width we also update the breakpoint.
    updateWidth() {
        const newWidth = this.getImgWidth();
        if (this.width === newWidth) return;

        this.width = this.getImgWidth();
        this.breakpoint = this.getBreakPoint();
    }

}


class BreakpointFinder {
    constructor(width) {
        this.width = width;
    }

    getKey() {
        if (this.width > BreakPoints.huge) return 'huge'
        if (this.width > BreakPoints.large) return 'large'
        if (this.width > BreakPoints.medium) return 'medium'
        if (this.width > BreakPoints.small) return 'small'
        if (this.width > BreakPoints.tiny) return 'tiny'
        return 'min';
    }
}

const BreakPoints = {
    "huge": 1200,
    "large": 900,
    "medium": 600,
    "small": 450,
    "tiny": 340,
    "min": 0,
}